/* ONENULL studio stage: hero carousel + card in-view lift. Loaded (deferred) by more than one section, so it guards itself. */
(function () {
  'use strict';
  if (window.onenullStage) return;
  window.onenullStage = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var touchOnly = window.matchMedia('(hover: none)');
  var SWIPE_MIN = 40;

  function HeroStage(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-stage-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-stage-dot]'));
    this.finishButtons = Array.prototype.slice.call(root.querySelectorAll('[data-stage-finish]'));
    this.indexEl = root.querySelector('[data-stage-index]');
    this.statusEl = root.querySelector('[data-stage-status]');
    this.stickyEl = root.querySelector('[data-stage-sticky]');
    this.pauseEl = root.querySelector('[data-stage-pause]');
    this.current = 0;
    this.timer = null;
    this.playing = false;
    this.interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    this.finish = root.getAttribute('data-finish') || 'black';
    this.total = parseInt(root.getAttribute('data-total'), 10) || this.slides.length;
    if (this.slides.length === 0) return;
    /* Speed r4: registered first, so the deferred gods/finishes are in the DOM before the slideshow, spin and
       preload (also first-input) run, and before any control's click handler. */
    var self = this;
    if (window.Shopify && window.Shopify.designMode) {
      this.hydrate();
    } else {
      onFirstInput(function () { self.hydrate(); });
    }
    this.bind();
    this.initSway();
    if (root.getAttribute('data-autoplay') === 'true' && this.total > 1 && !reduceMotion.matches) {
      this.armAutoplay();
    } else {
      this.syncPause();
      this.announce(true);
    }
    this.deferPreload();
  }

  /* Speed: don't fetch the next autoplay frame during the initial (LCP) load. Rev3 merge: warm it on the first
     interaction only (same trigger as the slideshow and the spin; no idle warm-up), so nothing beyond the LCP still
     is requested before input. Slide changes (go / setFinish) still preload the next frame. */
  HeroStage.prototype.deferPreload = function () {
    var self = this;
    onFirstInput(function () { self.preloadNext(); });
  };

  /* Speed rev3: the slideshow starts on the first interaction instead of at load, so slide swaps (new images,
     stage-in animations, layout) stay out of the initial load. A click on prev/next/dots still stops it. */
  /* Rev3 merge: no 'scroll' (the page can scroll itself during load, e.g. the preview bar or scroll restoration,
     which fired this at ~600 ms in a Lighthouse run and pulled the 1.2 MB spin), and 'pointermove' only counts when
     the pointer really moved (Chrome sends synthetic zero-movement moves after layout). Touch scrolling still fires
     touchstart, mouse-wheel scrolling fires wheel, keyboard scrolling fires keydown. */
  var FIRST_INPUT = ['pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel'];

  /* Speed r4: the server renders only the first god in its default finish; everything else waits in an inert
     <template data-stage-deferred>. Move it in once: the first god's other finishes go into its media box, the
     other gods are appended (hidden) after it. Safe to call repeatedly. */
  HeroStage.prototype.hydrate = function () {
    if (this.hydrated) return;
    this.hydrated = true;
    var tpl = this.root.querySelector('template[data-stage-deferred]');
    if (!tpl || !tpl.content) return;
    var frag = document.importNode(tpl.content, true);
    var finish = this.finish;
    var extra = frag.querySelector('[data-stage-first-shots]');
    if (extra) {
      var media = this.slides[0].querySelector('.stage__media');
      while (extra.firstChild) {
        var node = extra.firstChild;
        if (media && node.nodeType === 1) {
          media.appendChild(node);
        } else {
          extra.removeChild(node);
        }
      }
      extra.parentNode.removeChild(extra);
    }
    frag.querySelectorAll('[data-finish-shot]').forEach(function (shot) {
      shot.hidden = shot.getAttribute('data-finish-shot') !== finish;
    });
    this.slides[0].querySelectorAll('[data-finish-shot]').forEach(function (shot) {
      shot.hidden = shot.getAttribute('data-finish-shot') !== finish;
    });
    var area = this.root.querySelector('[data-stage-slides]');
    area.appendChild(frag);
    tpl.parentNode.removeChild(tpl);
    this.slides = Array.prototype.slice.call(this.root.querySelectorAll('[data-stage-slide]'));
    this.slides.forEach(function (slide, i) { if (i !== 0) slide.hidden = true; });
    if (this.swayEls) {
      var known = this.swayEls;
      this.swayEls = Array.prototype.slice.call(this.root.querySelectorAll('[data-spin]'));
      if (known.length === 0 && this.swayEls.length && !reduceMotion.matches && !this.swayObserved) this.observeSway();
    }
  };
  function onFirstInput(fn) {
    var fired = false;
    var once = function (e) {
      if (fired) return;
      if (e && e.type === 'pointermove' && !(e.isTrusted && (e.movementX || e.movementY))) return;
      fired = true;
      FIRST_INPUT.forEach(function (t) { window.removeEventListener(t, once, true); });
      fn();
    };
    FIRST_INPUT.forEach(function (t) { window.addEventListener(t, once, { capture: true, passive: true }); });
  }

  HeroStage.prototype.armAutoplay = function () {
    var self = this;
    this.syncPause();
    this.announce(true);
    onFirstInput(function () { self.play(); });
  };

  HeroStage.prototype.bind = function () {
    var self = this;
    var root = this.root;

    var prev = root.querySelector('[data-stage-prev]');
    var next = root.querySelector('[data-stage-next]');
    if (prev) prev.addEventListener('click', function () { self.interact(); self.go(self.current - 1); });
    if (next) next.addEventListener('click', function () { self.interact(); self.go(self.current + 1); });

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.interact();
        self.go(parseInt(dot.getAttribute('data-stage-dot'), 10));
      });
    });

    this.finishButtons.forEach(function (btn) {
      var prefetch = function () { self.prefetchFinish(btn.getAttribute('data-stage-finish')); };
      btn.addEventListener('pointerenter', prefetch);
      btn.addEventListener('focus', prefetch);
      btn.addEventListener('click', function () {
        self.interact();
        self.finishPicked = true;
        self.setFinish(btn.getAttribute('data-stage-finish'));
      });
    });

    if (this.pauseEl) {
      this.pauseEl.hidden = reduceMotion.matches;
      this.pauseEl.addEventListener('click', function () {
        if (self.playing) {
          self.stop();
        } else {
          self.play();
        }
      });
    }

    root.addEventListener('keydown', function (e) {
      var tag = e.target && e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (e.key === 'ArrowLeft') { self.interact(); self.go(self.current - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { self.interact(); self.go(self.current + 1); e.preventDefault(); }
    });

    var startX = null;
    var startY = 0;
    var area = root.querySelector('[data-stage-slides]');
    area.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      startX = e.clientX;
      startY = e.clientY;
    });
    area.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy)) return;
      self.interact();
      self.go(self.current + (dx < 0 ? 1 : -1));
    });
    area.addEventListener('pointercancel', function () { startX = null; });
    area.addEventListener('dragstart', function (e) { e.preventDefault(); });

    document.addEventListener('visibilitychange', function () {
      if (!self.playing) return;
      if (document.hidden) {
        clearInterval(self.timer);
      } else {
        self.schedule();
      }
    });

    var onMotionChange = function () {
      if (reduceMotion.matches) {
        self.stop();
        self.wakeSway();
        self.swayEls.forEach(function (el) { el.classList.remove('is-spinning'); });
      }
      if (self.pauseEl) self.pauseEl.hidden = reduceMotion.matches;
    };
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onMotionChange);
  };

  HeroStage.prototype.go = function (index) {
    this.hydrate();
    var n = this.slides.length;
    var i = ((index % n) + n) % n;
    if (i === this.current) return;
    this.root.classList.add('is-moved');
    this.slides[this.current].hidden = true;
    this.slides[i].hidden = false;
    this.current = i;

    this.dots.forEach(function (dot, d) {
      if (d === i) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
    if (this.indexEl) this.indexEl.textContent = String(i + 1).padStart(2, '0');

    var slide = this.slides[i];
    if (this.stickyEl) {
      this.stickyEl.textContent = slide.getAttribute('data-cta-label');
      this.stickyEl.setAttribute('aria-label', slide.getAttribute('data-cta-aria'));
      this.stickyEl.setAttribute('href', slide.getAttribute('data-cta-href'));
    }
    this.announce(false);
    this.preloadNext();
    this.wakeSway();
  };

  HeroStage.prototype.setFinish = function (finish) {
    if (!finish) return;
    this.hydrate();
    this.finish = finish;
    this.root.setAttribute('data-finish', finish);
    this.root.querySelectorAll('[data-finish-shot]').forEach(function (shot) {
      shot.hidden = shot.getAttribute('data-finish-shot') !== finish;
    });
    this.finishButtons.forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-stage-finish') === finish ? 'true' : 'false');
    });
    this.preloadNext();
    this.wakeSway();
  };

  /*
   * Floating cutouts: a looping 360 spin stored as a "stacked alpha" MP4 (colour premultiplied on black in the top
   * half, alpha as grey in the bottom half), recombined in WebGL so it is transparent in every browser incl. iOS Safari.
   * The still <img> stays visible until the first video frame is drawn, and whenever WebGL or autoplay is unavailable.
   */
  HeroStage.prototype.initSway = function () {
    var self = this;
    this.swayEls = Array.prototype.slice.call(this.root.querySelectorAll('[data-spin]'));
    this.swayActive = null;
    this.swayVisible = true;
    this.swayReady = false;
    if (reduceMotion.matches) return;
    /* r4: the first god's own cutout may be server-rendered while the rest arrive on hydrate(). */
    if (this.swayEls.length) this.observeSway();
    /* Speed rev3: the spin (1.2 MB MP4 + a WebGL texture upload per frame) starts on the first interaction, not on
       idle, so it never runs during the initial load. The still <img> (the LCP element) shows until then. */
    onFirstInput(function () { self.swayReady = true; self.wakeSway(); });
  };

  HeroStage.prototype.observeSway = function () {
    var self = this;
    this.swayObserved = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        self.swayVisible = entries[0].isIntersecting;
        self.wakeSway();
      }).observe(this.root);
    }
  };

  HeroStage.prototype.currentSway = function () {
    var shot = this.slides[this.current].querySelector('[data-finish-shot="' + this.finish + '"]');
    return shot ? shot.querySelector('[data-spin]') : null;
  };

  HeroStage.prototype.wakeSway = function () {
    if (!this.swayReady) return;
    var prev = this.swayActive;
    var el = reduceMotion.matches || !this.swayVisible ? null : this.currentSway();
    this.swayActive = el;
    var sameGod = el && prev && prev.spin &&
      prev.closest('[data-stage-slide]') === el.closest('[data-stage-slide]');
    var angle = sameGod ? prev.spin.video.currentTime : null;
    var offscreen = !this.swayVisible;
    this.swayEls.forEach(function (other) {
      if (other === el || !other.spin) return;
      if (offscreen) {
        other.spin.video.pause();
      } else {
        destroySpin(other);
      }
    });
    if (!el) return;
    if (!el.spin && !el.spinFailed) {
      el.spin = createSpin(el);
      el.spinFailed = !el.spin;
    }
    if (!el.spin) return;
    var src = (!this.finishPicked && el.getAttribute('data-spin-cycle')) || el.getAttribute('data-spin');
    var self = this;
    el.spin.want = src;
    loadSpin(src, function (url) {
      if (!el.spin || el.spin.want !== src || self.swayActive !== el) return;
      var video = el.spin.video;
      var switched = el.spin.src !== src;
      if (switched) {
        el.spin.src = src;
        video.src = url;
        el.spin.lastTime = -1;
      }
      if (angle !== null && (switched || prev !== el)) seekSpin(video, angle);
      var play = video.play();
      if (play && play.catch) play.catch(function () {});
      self.runSway();
    });
  };

  HeroStage.prototype.prefetchFinish = function (finish) {
    if (!this.swayReady || reduceMotion.matches) return;
    this.hydrate();
    var shot = this.slides[this.current].querySelector('[data-finish-shot="' + finish + '"] [data-spin]');
    if (shot) loadSpin(shot.getAttribute('data-spin'), function () {});
  };

  HeroStage.prototype.runSway = function () {
    var self = this;
    if (this.swayRaf) return;
    var tick = function () {
      self.swayRaf = null;
      var el = self.swayActive;
      if (!el || !el.spin) return;
      self.swayRaf = requestAnimationFrame(tick);
      drawSpin(el);
    };
    this.swayRaf = requestAnimationFrame(tick);
  };

  var SPIN_VERT = 'attribute vec2 p;varying vec2 uv;void main(){uv=vec2((p.x+1.)*.5,(1.-p.y)*.5);gl_Position=vec4(p,0.,1.);}';
  var SPIN_FRAG = 'precision mediump float;varying vec2 uv;uniform sampler2D t;void main(){' +
    'vec3 c=texture2D(t,vec2(uv.x,uv.y*.5)).rgb;float a=texture2D(t,vec2(uv.x,.5+uv.y*.5)).r;' +
    'gl_FragColor=vec4(min(c,vec3(a)),a);}';

  function createSpin(el) {
    var canvas = el.querySelector('.stage__spin');
    var gl = canvas && canvas.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false });
    if (!gl) return null;
    var program = gl.createProgram();
    [[gl.VERTEX_SHADER, SPIN_VERT], [gl.FRAGMENT_SHADER, SPIN_FRAG]].forEach(function (s) {
      var shader = gl.createShader(s[0]);
      gl.shaderSource(shader, s[1]);
      gl.compileShader(shader);
      gl.attachShader(program, shader);
    });
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;
    gl.useProgram(program);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(program, 'p');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    gl.bindTexture(gl.TEXTURE_2D, gl.createTexture());
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

    var video = document.createElement('video');
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.preload = 'auto';
    video.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none';
    el.appendChild(video);
    return { gl: gl, canvas: canvas, video: video, lastTime: -1 };
  }

  /* Browsers cap live WebGL contexts (~16), so a cutout that leaves the stage gives its context and decoder back. */
  function destroySpin(el) {
    var s = el.spin;
    el.spin = null;
    el.classList.remove('is-spinning');
    s.video.pause();
    s.video.removeAttribute('src');
    s.video.load();
    s.video.remove();
    var lose = s.gl.getExtension('WEBGL_lose_context');
    if (lose) lose.loseContext();
    s.canvas.replaceWith(s.canvas.cloneNode(false));
  }

  /* Spin videos are fetched whole and played from a blob URL: always seekable, and a finish seen once switches instantly. */
  var spinCache = {};
  function loadSpin(src, done) {
    var entry = spinCache[src];
    if (!entry) {
      entry = spinCache[src] = { url: null, waiting: [] };
      var finish = function (url) {
        entry.url = url;
        entry.waiting.forEach(function (fn) { fn(url); });
        entry.waiting = [];
      };
      if (window.fetch && window.URL && URL.createObjectURL) {
        fetch(src).then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.blob();
        }).then(function (blob) {
          finish(URL.createObjectURL(blob));
        }).catch(function () { finish(src); });
      } else {
        finish(src);
      }
    }
    if (entry.url) {
      done(entry.url);
    } else {
      entry.waiting.push(done);
    }
  }

  /* Every finish shares one camera and crop, so the same time is the same angle: switching finish keeps the spin going. */
  function seekSpin(video, time) {
    var apply = function () { video.currentTime = time % (video.duration || Infinity); };
    if (video.readyState >= 1) {
      apply();
    } else {
      video.addEventListener('loadedmetadata', apply, { once: true });
    }
  }

  function drawSpin(el) {
    var s = el.spin;
    var v = s.video;
    if (v.readyState < 2 || v.currentTime === s.lastTime) return;
    s.lastTime = v.currentTime;
    var gl = s.gl;
    gl.viewport(0, 0, s.canvas.width, s.canvas.height);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, v);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    el.classList.add('is-spinning');
  }

  /* The next slide's visible image is hidden (display:none), so lazy loading would wait until it is shown. */
  HeroStage.prototype.preloadNext = function () {
    if (this.slides.length < 2) return;
    var next = this.slides[(this.current + 1) % this.slides.length];
    var shot = next.querySelector('[data-finish-shot="' + this.finish + '"] img');
    if (shot && shot.loading === 'lazy') shot.loading = 'eager';
  };

  HeroStage.prototype.announce = function (initial) {
    if (!this.statusEl) return;
    this.statusEl.setAttribute('aria-live', this.playing ? 'off' : 'polite');
    if (initial) return;
    var slide = this.slides[this.current];
    this.statusEl.textContent = slide.getAttribute('data-name') + ', ' + (this.current + 1) + ' of ' + this.total;
  };

  HeroStage.prototype.schedule = function () {
    var self = this;
    clearInterval(this.timer);
    this.timer = setInterval(function () { self.go(self.current + 1); }, this.interval);
  };

  HeroStage.prototype.play = function () {
    if (reduceMotion.matches || this.total < 2) return;
    this.hydrate();
    this.playing = true;
    this.schedule();
    this.syncPause();
  };

  HeroStage.prototype.stop = function () {
    this.playing = false;
    clearInterval(this.timer);
    this.timer = null;
    this.syncPause();
  };

  HeroStage.prototype.interact = function () {
    if (this.playing) this.stop();
  };

  HeroStage.prototype.syncPause = function () {
    if (this.statusEl) this.statusEl.setAttribute('aria-live', this.playing ? 'off' : 'polite');
    if (!this.pauseEl) return;
    this.pauseEl.setAttribute('aria-pressed', this.playing ? 'false' : 'true');
    this.pauseEl.setAttribute('aria-label', this.playing ? 'Pause slideshow' : 'Play slideshow');
  };

  function initHeroes(scope) {
    scope.querySelectorAll('[data-hero-stage]').forEach(function (root) {
      if (root.stageController) return;
      root.stageController = new HeroStage(root);
    });
  }

  var cardObserver = null;
  function initCards(scope) {
    if (!touchOnly.matches || reduceMotion.matches || !('IntersectionObserver' in window)) return;
    if (!cardObserver) {
      cardObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          cardObserver.unobserve(entry.target);
        });
      }, { threshold: 0.45 });
    }
    scope.querySelectorAll('.stage-card:not([data-inview-bound])').forEach(function (card) {
      card.setAttribute('data-inview-bound', '');
      cardObserver.observe(card);
    });
  }

  function init(scope) {
    initHeroes(scope);
    initCards(scope);
  }

  /* Rev3 merge: card finishes that are not on show carry data-src/data-srcset only. Load one on hover/focus of its
     finish button (intent), and on click at the latest (below), so the swap does not flash an empty frame. */
  /* Speed r4: those other finishes are not in the HTML at all any more: the card's cutout box carries
     data-card-src-{finish} (the still's asset URL) and the <img> is built here from the shown one. */
  function loadCardShot(img) {
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
  }
  function cardShot(card, finish) {
    var shot = card.querySelector('[data-card-shot="' + finish + '"]');
    if (shot) return shot;
    var cut = card.querySelector('.stage-card__cut');
    var src = cut && cut.getAttribute('data-card-src-' + finish);
    var model = cut && cut.querySelector('[data-card-shot]');
    if (!src || !model) return null;
    var was = model.getAttribute('data-card-shot');
    shot = model.cloneNode(false);
    shot.className = model.className.replace('stage-card__img--' + was, 'stage-card__img--' + finish);
    shot.setAttribute('data-card-shot', finish);
    shot.alt = (model.getAttribute('alt') || '').replace(new RegExp(' in ' + was + '$'), ' in ' + finish);
    shot.removeAttribute('loading');
    shot.srcset = src + '&width=240 240w, ' + src + '&width=400 400w, ' + src + ' 544w';
    shot.src = src + '&width=400';
    shot.setAttribute('aria-hidden', 'true');
    cut.removeAttribute('data-card-src-' + finish);
    cut.appendChild(shot);
    return shot;
  }
  function warmCardFinish(e) {
    var btn = e.target.closest && e.target.closest('[data-card-finish]');
    if (!btn) return;
    var card = btn.closest('.stage-card');
    var shot = card && cardShot(card, btn.getAttribute('data-card-finish'));
    if (shot) loadCardShot(shot);
  }
  document.addEventListener('pointerover', warmCardFinish, { passive: true });
  document.addEventListener('focusin', warmCardFinish);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-card-finish]');
    if (!btn) return;
    var card = btn.closest('.stage-card');
    var finish = btn.getAttribute('data-card-finish');
    cardShot(card, finish);
    card.setAttribute('data-finish', finish);
    card.querySelectorAll('[data-card-finish]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    card.querySelectorAll('[data-card-shot]').forEach(function (img) {
      if (img.getAttribute('data-card-shot') === finish) {
        loadCardShot(img);
        img.removeAttribute('aria-hidden');
      } else {
        img.setAttribute('aria-hidden', 'true');
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-hero-stage]').forEach(function (root) {
      if (root.stageController) root.stageController.stop();
    });
  });
})();
